import {
  FETCHING_PLANS,
  SET_PLANS,
  ERROR_PLANS,
} from '../actions/billingActions';

const initialState = {
  plans: [],
  fetchingPlans: false,
  fetchingError: false,
};

export default (state = initialState, action) => {
  switch (action.type) {
    case SET_PLANS:
      return { ...state, plans: action.payload };
    case FETCHING_PLANS:
      return { ...state, fetchingPlans: action.payload };
    case ERROR_PLANS:
      return { ...state, fetchingError: action.payload };
    default:
      return state;
  }
};
